import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { MeDTO } from '@amrita/shared';

export function useMe() {
  return useQuery<MeDTO>({
    queryKey: ['me'],
    queryFn: () => api.get<MeDTO>('/api/me'),
    // 401 не станет успешным при повторе — retry только откладывает показ логина.
    retry: false,
  });
}
